<template>
    <div class="main bbt-main bbt-main">
        <div class="author-banner" style="height:80px;">
            <div class="author-banner__bg" :style="{backgroundImage:`url(${publicPath}default/document-bg@2x.webp)`,height:'400px'}">
                <div class="bbt-container"></div>
            </div>
        </div>
        <div class="bbt-container">
            <div class="document-module">
                <h3 class="document-module__title typo-h3"><span class="square"><i></i><i></i></span>关于我们</h3>
                <div class="document-module__content">
                    <div>
                        <div v-if="aboutId == 1">
                            <h2>关于平台</h2>
                            <p>本平台是由贵州省R3UV新一代信息技术科普示范基地（黔科合平台人才[2017]5501）和贵州省新一代信息技术科普服务平台
                                （黔科协普发[2019]66号）项目资助建设，旨在围绕智能科学、机器人、无人机车、3D打印、虚拟现实、物联网、大数据、区块链、信息安全等新一代信息技术相关领域，
                                打造集信息技术科普示范教育、科技传播推广、科技交流咨询等于一体的网络信息化科普服务和科技交流平台。</p><br>
                        </div>
                        <div v-else-if="aboutId == 2">
                            <h2>联系方式</h2>
                            <p><b>邮箱：</b>358826523#qq.cm（发送邮件时请把#号换成@号）</p>
                            <p><b>手机：</b>180_101_52976</p>
                        </div>
                        <div v-else>
                            <h2>欢迎加入</h2>
                            <p>特邀拥有信息技术科技背景的专家、学者和技术人士加入我们，参与科技引领、科普内容提供与创作、科普演讲、科技知识答疑与咨询服务等活动。
                                欢迎拥有信息技术科技产品的机构、单位或个人加入我们，通过平台向民众展示先进的科技产品。
                                欢迎拥有信息技术科技热情的您加入我们，参与信息技术科技前沿和科技活动的跟踪报道。</p>
                            <p><b>邮箱：</b>358826523#qq.cm（发送邮件时请把#号换成@号）</p>
                            <p><b>手机：</b>180_101_52976</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'AboutDetail',
    props: {
        serveHost: String,
        aboutName: String
    },
    data () {
        return {
            publicPath: process.env.BASE_URL,
            book:{},
            aboutId:0
        }
    },
    created() {
        this.aboutId = this.$route.params.book_id;
    }
}
</script>

<style scoped>
/* banner图部分 */
.author-banner {
    width: 100%;
    height: 160px;
    text-align: center;
    background: #1e1e1e;
}
.author-banner__bg {
    padding: 18px 0;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    color: #fff;
}

/* 内容部分 */
.document-module__content div p {
    text-indent:2em;
    margin-top:10px;
    line-height:30px;
}
.document-module {
    padding: 56px;
    background: #fff;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
    border-radius: 4px;
}
.document-module__title {
    margin: 0;
    padding-bottom: 40px;
    border-bottom: 1px dashed rgba(0,0,0,.08);
    text-align: center;
}
.typo-h3 {
    font-size: 38px;
    line-height: 46px;
    font-weight: 700;
}
.document-module__title .square {
    display: inline-block;
    width: 20px;
    height: 20px;
    position: relative;
    margin-right: 16px;
}
.document-module__title .square i {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 0;
    top: 0;
    background: #e00;
    border-radius: 2px;
}
.document-module__title .square i+i {
    width: 12px;
    height: 12px;
    position: absolute;
    left: 8px;
    top: 8px;
    opacity: .5;
    background: #e00;
    border-radius: 2px;
}
.document-module__content {
    padding-top: 40px;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.88);
}
</style>